<template>
    <v-dialog v-model="open" width="632px" :fullscreen="isMobileBreakpoint">
        <v-card dense>
            <v-toolbar class="pa-7 pb-0" elevation="0">
                <v-toolbar-title class="body-regular-medium font-weight-medium" :class="{
                    'neutral-20-dark--text': !$vuetify.theme.dark,
                }" style="line-height: 120%">
                    {{ $t('message.pages.drm.drmApparence.restoreModal.title') }}
                </v-toolbar-title>
                <v-icon @click="handleCloseDrmToggleStatus" class="close-icon ml-auto" size="24" color="grey"
                    style="cursor: pointer">
                    mdi-close
                </v-icon>
            </v-toolbar>
            <v-card-text class="px-7 pb-4">
                <span class="body-regular-small"> {{ $t('message.pages.drm.drmApparence.restoreModal.description')
                }}</span>
            </v-card-text>
            <v-card-actions class="pa-7 card-actions" :class="{ 'mobile-actions': isMobileBreakpoint }">
                <v-spacer v-if="!isMobileBreakpoint"></v-spacer>
                <base-btn type="tertiary" class="mr-3" text @click="handleCloseDrmToggleStatus" :disabled="isFetching">
                    {{ $t('message.cancel') }}
                </base-btn>
                <base-btn :disabled="isFetching" :loading="isFetching" @click="handleConfirm">
                    <span>{{
                        $t('message.playerPage.restoreSettingsModal.action')
                    }}</span>
                </base-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import drmApi from '@/services/drmApi'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    components: {},
    data: () => ({
        open: false,
        isFetching: false,
        countVideos: 0,
        selectedKeys: [],
        selectedGroup: {
            name: '',
            id: '',
        },
        removeText: '',
        password: '',
        showPassword: false,
        permanentConfirm: false,
        passwordError: false,
        passwordErrorMessage: '',
        apiError: null,
    }),
    computed: {
        ...mapState('user', {
            isMobileBreakpoint: 'isMobileBreakpoint',
            isTabletBreakpoint: 'isTabletBreakpoint',
        }),
        isMultiple() {
            return !!this.selectedKeys?.length
        },
        canConfirm() {
            return this.permanentConfirm
        },
        passwordErrorMessages() {
            return this.passwordError
                ? [this.$t('message.pages.drm.modal.removeGroup.inputPasswordInvalid')]
                : []
        },
    },
    mounted() {
        this.$root.$on('drmRestoreApparece', ({ groupId }) => {
            this.resetState()
            this.groupId = groupId
            console.log(groupId)
            this.hideCrispButton()
            this.open = true
        })
    },
    beforeDestroy() {
        this.$root.$off('drmRemoveGroupModal')
        this.selectedKeys = []
        this.showCrispButton()
    },
    methods: {
        ...mapActions('session', ['signInUser']),
        ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
        resetState() {
            this.passwordError = false
            this.passwordErrorMessage = ''
            this.showCrispButton()
        },
        async validatePassword() {
            this.passwordError = false
            this.passwordErrorMessage = ''
            try {
                await this.signInUser({
                    username: this.$store.getters['session/userAttributes'].email,
                    password: this.password,
                })
                return true
            } catch (error) {
                this.passwordError = true
                this.passwordErrorMessage = this.$t(
                    'message.pages.drm.modal.removeGroup.inputPasswordInvalid'
                )
                return false
            }
        },
        handleConfirm() {
            let groupObject = {
                'font-family': 'rubik',
                'font-color': '#FFFFFF',
                'font-size': '12',
                'box-color': '#00000066',
                'box-opacity': '1',
            }
            this.handleEdit(groupObject)
        },
        async handleEdit(groupObject) {
            this.isFetching = true
            this.$root.$emit('isBtnloading', true)
            try {
                let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
                this.isFetching = false
                this.$root.$emit('updateDrmGroup', ret.data)
                this.$root.$emit('updateDrmGroupStart', ret.data)
                this.UPDATE_GLOBAL_SNACKBAR({
                    open: true,
                    type: 'success',
                    text: this.$t('message.pages.drm.drmApparence.tooltip'),
                })
                this.handleCloseDrmToggleStatus()
                this.$root.$emit('isBtnloading', false)
            } catch (e) {
                this.isFetching = false
                this.$root.$emit('isBtnloading', false)
                console.log('e', e)
            }
        },
        handleCloseDrmToggleStatus() {
            this.open = false
            this.removeText = ''
            this.password = ''
            this.permanentConfirm = false
            this.showPassword = false
            this.showCrispButton()
        },
        hideCrispButton() {
            const crispButton = document.querySelector('.crisp-client')
            if (crispButton && this.isMobileBreakpoint) {
                crispButton.style.setProperty('display', 'none', 'important')
            }
        },
        showCrispButton() {
            const crispButton = document.querySelector('.crisp-client')
            if (crispButton) {
                crispButton.style.removeProperty('display')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar {
    height: 64px !important;
}

::v-deep .v-toolbar__content {
    padding: 0 !important;
    align-items: flex-start !important;
}

.input::v-deep {
    label {
        left: -10px !important;
    }

    input::placeholder {
        font-size: 12px !important;
    }
}

.card-actions {
    border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}

.mobile-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    .base-button {
        width: 50%;
    }
}
</style>
